export default "/images/e2444b65d61cba35b6d1697abce054fb.jpg";